webpackJsonp([231547272361986],{

/***/ 458:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "",
				"frontmatter": {
					"title": "dmgt test doc # 2"
				},
				"fields": {
					"slug": "/dmgt-test-doc-2"
				}
			}
		},
		"pathContext": {
			"slug": "/dmgt-test-doc-2"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---dmgt-test-doc-2-4576024442deeb84c4f6.js